import React from 'react';

/**
 * Mediation (inferred): each SDK-bidding buyer's participation and outcome for
 * one slot — invited (in the GAM a3p buyer list), fired (sdk_bidding traffic seen
 * in the timing window), won (billing notice, or GAM's adapterLabel). Never proven.
 * Shared by the Lifecycle and Slots tabs.
 */

const CHIP = {
  fontSize: 9.5, padding: '1px 7px', borderRadius: 20, fontWeight: 500,
  background: 'var(--surface)', color: 'var(--muted)', border: '1px solid var(--line)',
};

export default function MediationBuyers({ mediation, style = {} }) {
  const buyers = mediation && Array.isArray(mediation.buyers) ? mediation.buyers : [];
  if (!buyers.length) return null;
  const reasons = Array.isArray(mediation.reasons) ? mediation.reasons : [];
  return (
    <div data-testid="mediation-buyers" style={style}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        <span style={{ fontSize: 9.5, color: 'var(--muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          Mediation
        </span>
        <span title="inferred — soft signal + timing (a3p buyer list / adapter / sdk_bidding traffic), never a hard token" style={{ ...CHIP, color: 'var(--warn-text)', borderColor: 'var(--warn-border)', background: 'var(--warn-bg)', fontWeight: 700 }}>
          ◐ Inferred
        </span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {buyers.map((b) => {
          const won = mediation.winner === b.id;
          return (
            <div key={b.id} style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', fontSize: 11 }}>
              <span style={{ fontWeight: 600, color: 'var(--ink)' }}>{b.name || b.id}</span>
              {b.reachedViaA3p && <span title="present in GAM row's a3p buyer list" style={CHIP}>invited</span>}
              {Array.isArray(b.rowKeys) && b.rowKeys.length > 0 && (
                <span title="sdk_bidding traffic observed within the timing window" style={{ ...CHIP, color: 'var(--success-text)', borderColor: 'var(--success-border)' }}>fired</span>
              )}
              {won && (
                <span title={mediation.winnerSource === 'bill' ? 'billing notice fired by this buyer — it rendered the ad' : 'named by GAM response adapterLabel'} style={{ ...CHIP, color: 'var(--success-text)', borderColor: 'var(--success-border)', background: 'var(--success-bg)', fontWeight: 700 }}>won</span>
              )}
              {b.outcome && <span style={{ color: 'var(--muted)' }}>{String(b.outcome).replace(/_/g, ' ')}</span>}
            </div>
          );
        })}
        {reasons.map((r, i) => (
          <span key={i} style={{ fontSize: 10.5, color: 'var(--warn-text)' }}>⚠ {r}</span>
        ))}
      </div>
    </div>
  );
}
